/**
 * Quill Delta encoding for phone-call notes.
 *
 * The backend `notes` field carries a Quill Delta — Flutter writes
 * `jsonEncode(document.toDelta().toJson())` (a BARE ops array, not a
 * `{"ops":[…]}` envelope — same form the macro flow uses) and the existing PA
 * client reads it back with `flutter_quill`'s `tryParseDocument`. A bare
 * plaintext string in `notes` therefore renders BLANK in that client.
 *
 * This port has no rich-text editor, so it captures plain text and encodes it
 * as a single-op Delta. flutter_quill requires the document to end in a
 * newline, so the insert text is newline-terminated (matching what
 * `Document.toDelta()` emits for a plain paragraph).
 */

/** Encode plain text as a bare Quill Delta ops-array JSON string for `notes`. */
export function plainTextToDeltaJson(text: string): string {
  const withTrailingNewline = text.endsWith('\n') ? text : `${text}\n`;
  return JSON.stringify([{ insert: withTrailingNewline }]);
}
